import { ApiFunc, getInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const assessment: ApiFunc<`${typeof API.ASSESSMENT}`, 'get'> = data =>
  instance.get(`${API.ASSESSMENT}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const assessmentCreate: ApiFunc<`${typeof API.ASSESSMENT}`, 'post'> = data => instance.post(API.ASSESSMENT, data)

export const assessmentStudentUpload: ApiFunc<`${typeof API.ASSESSMENT_STUDENT_UPLOAD}`, 'post'> = data =>
  instance.post(API.ASSESSMENT_STUDENT_UPLOAD, data)

export const assessmentList: ApiFunc<`${typeof API.ASSESSMENT}`, 'get'> = data =>
  instance.get(API.ASSESSMENT, {
    params: data,
  })

export const assessmentBulk: ApiFunc<`${typeof API.ASSESSMENT_BULK}`, 'post'> = data =>
  instance.post(API.ASSESSMENT_BULK, data)

export const assessmentLogModal: ApiFunc<`${typeof API.ASSESSMENT_LOG_MODAL}`, 'post'> = data =>
  instance.post(API.ASSESSMENT_LOG_MODAL, data)

export const assessmentAttempt: ApiFunc<`${typeof API.ASSESSMENT_ATTEMPT}`, 'post'> = data =>
  instance.post(API.ASSESSMENT_ATTEMPT, data)

export const getAssessmentAttemptById: ApiFunc<`${typeof API.ASSESSMENT_ATTEMPT}`, 'get'> = data =>
  instance.get(API.ASSESSMENT_ATTEMPT, {
    params: data,
  })

export const assessmentCopy: ApiFunc<`${typeof API.ASSESSMENT_COPY}`, 'post'> = data =>
  instance.post(API.ASSESSMENT_COPY, data)

export const assessmentSubmit: ApiFunc<`${typeof API.ASSESSMENT_SUBMIT}`, 'post'> = data =>
  instance.post(API.ASSESSMENT_SUBMIT, data)

export const assessmentCriteria: ApiFunc<`${typeof API.ASSESSMENT_CRITERIA}`, 'get'> = data =>
  instance.get(API.ASSESSMENT_CRITERIA, {
    params: data,
  })

export const assessmentCriteriaUpdate: ApiFunc<`${typeof API.ASSESSMENT_CRITERIA}`, 'post'> = data =>
  instance.post(API.ASSESSMENT_CRITERIA, data)

export const assessmentCriteriaList: ApiFunc<`${typeof API.ASSESSMENT_CRITERIA_LIST}`, 'get'> = data =>
  instance.get(API.ASSESSMENT_CRITERIA_LIST, {
    params: data,
  })

export const assessmentCriteriaStatus: ApiFunc<`${typeof API.ASSESSMENT_CRITERIA_STATUS}`, 'get'> = data =>
  instance.get(API.ASSESSMENT_CRITERIA_STATUS, {
    params: data,
  })

export const attemptDelete: ApiFunc<`${typeof API.ASSESSMENT_ATTEMPT}`, 'delete'> = data =>
  instance.delete(API.ASSESSMENT_ATTEMPT, {
    params: data,
  })

export const assessmentCriteriaTypes: ApiFunc<`${typeof API.ASSESSMENT_CRITERIA_TYPES}`, 'get'> = data =>
  instance.get(API.ASSESSMENT_CRITERIA_TYPES, {
    params: data,
  })

export const assessmentStudent: ApiFunc<`${typeof API.ASSESSMENT_STUDENT}`, 'get'> = data =>
  instance.get(API.ASSESSMENT_STUDENT, {
    params: data,
  })

export const assessmentStudentUpdated: ApiFunc<`${typeof API.ASSESSMENT_STUDENT_UPDATED}`, 'get'> = data =>
  instance.get(API.ASSESSMENT_STUDENT_UPDATED, {
    params: data,
  })

export const assessmentStudentCriteriaDetails: ApiFunc<
  `${typeof API.ASSESSMENT_STUDENT_CRITERIA_DETAILS}`,
  'get'
> = data =>
  instance.get(API.ASSESSMENT_STUDENT_CRITERIA_DETAILS, {
    params: data,
  })

export const assessmentStudentQrSave: ApiFunc<`${typeof API.ASSESSMENT_STUDENT_QR_SAVE}`, 'post'> = data =>
  instance.post(API.ASSESSMENT_STUDENT_QR_SAVE, data, {
    responseType: 'blob',
  })

export const assessmentStudentQrList: ApiFunc<`${typeof API.ASSESSMENT_STUDENT_QR_LIST}`, 'post'> = data =>
  instance.post(API.ASSESSMENT_STUDENT_QR_LIST, data, {
    responseType: 'blob',
  })

export const assessmentCreateModeration: ApiFunc<`${typeof API.ASSESSMENT_MODERATION}`, 'post'> = data =>
  instance.post(API.ASSESSMENT_MODERATION, data)

export const assessmentQrUpload: ApiFunc<`${typeof API.ASSESSMENT_QR_UPLOAD}`, 'post'> = data =>
  instance.post(API.ASSESSMENT_QR_UPLOAD, data, { headers: { 'Content-Type': 'multipart/form-data' } })
